import { connect, MapStateToProps } from 'react-redux';
import { Url } from '@wix/da-url';
import { AppState } from '../../../../types/store';
import {
  getProfileOwnerUser,
  getProfileOwnerStats,
  getProfileOwnerTagline,
  getCanCustomizePage,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import { getModuleIdByModuleType } from '../../../selectors/modules';
import { Props } from './ProfileIdentity';
import { ModuleType } from '../../../../types/modules';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags/selectors';

export type StateProps = Pick<
  Props,
  | 'profileOwnerUser'
  | 'tagline'
  | 'url'
  | 'stats'
  | 'aboutModuleId'
  | 'isOwner'
  | 'withNewCoreSymbol'
  | 'isAuthorizedToCustomize'
>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const profileOwnerUser = getProfileOwnerUser(state);
  return {
    profileOwnerUser,
    tagline: getProfileOwnerTagline(state) || '',
    stats: getProfileOwnerStats(state),
    isOwner: isCurrentUserProfileOwner(state),
    url: Url.userLink(profileOwnerUser.username),
    aboutModuleId: getModuleIdByModuleType(state, ModuleType.ABOUT),
    withNewCoreSymbol: flagEnabled(state, 'new_core_symbols'),
    isAuthorizedToCustomize: getCanCustomizePage(state),
  };
};

export default connect(mapStateToProps);
